import axios, { AxiosError } from "axios";
import { configure } from "axios-hooks";

import config from "config";

const axiosInstance = axios.create({
  withCredentials: true,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
  baseURL: config.LINK_API_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

configure({ axios: axiosInstance, cache: false });

export default axiosInstance;
